function toTenantFlag(value) {
  if (value === true || value === 1 || value === '1' || value === 'true') {
    return 1;
  }
  return 0;
}

function toTenantText(value) {
  if (typeof value !== 'string') {
    return '';
  }
  return value;
}

export function normalizeTenantRecord(tenant = false) {
  if (!tenant || typeof tenant !== 'object') {
    return tenant;
  }

  const normalized = { ...tenant };

  normalized.requiresCopyrightAcknowledgement = toTenantFlag(
    normalized.requiresCopyrightAcknowledgement
  );
  normalized.copyrightStatement = toTenantText(normalized.copyrightStatement);

  return normalized;
}

export function buildTenantSavePayload(existingTenant = {}, updates = {}) {
  const merged = {
    ...existingTenant,
    ...updates,
  };

  return normalizeTenantRecord(merged);
}
